<template>
<div class="animated fadeIn">

  <CCard>
    <CCardHeader>
      <slot name="header">
        <span class="title-card-list"><i class="fa fa-align-justify mr-1"></i>
        {{ title }}</span>
      </slot>

      <div class="card-header-actions">
        <CBadge class="pull-right" style="padding: 0.3rem 0.5rem;" pill color="dark">Total: {{ paymentsList.length  }}</CBadge>
      </div>
    </CCardHeader>

    <div v-if="loading" class="text-center m-5">
      <div class="spinner-grow text-primary m-auto" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div v-else>

      <CCardBody>

        <CDataTable
          :items="paymentsList"
          :fields="campos"
          column-filter
          sorter
          clickable-rows
          hover
          @row-clicked="goToDetail"
          :noItemsView="{ noResults: ' sin resultados disponibles ' , noItems: ' sin resultados' }"
        >
        <!--  @row-clicked="rowClicked" -->

          <!-- <template #under-table>
            <div d-flex flex-row class="acciones-disponibles mb-3 row-over-table">
              <div>
                <CDropdown id="dropdown-acciones" toggler-text="Acciones globales" squared class="m-md-2" color="primary">
                  <CDropdownItem @click="selectAllItems">
                    <span v-if="allChecked"><i class="fa fa-square-o fa-lg"></i> Deseleccionar todos</span>
                    <span v-else><i class="fa fa-check-square-o fa-lg"></i> Seleccionar todos</span>
                  </CDropdownItem>

                  <CDropdownDivider></CDropdownDivider>
                  <CDropdownItem @click="modelDelete = true"><span><i class="fa fa-remove fa-lg" style="color: red;"></i> Eliminar marcados</span></CDropdownItem>
                </CDropdown>
              </div>
            </div>
          </template> -->


          <template #over-table v-if="excel">
            <div d-flex flex-row class="acciones-disponibles mb-3 row-over-table">
              <CButton :disabled="loading"  @click="generateExcel"
                v-c-tooltip.hover.click="'Ajusta el listado con el Filtro de Pagos'"
                class="mr-2" type="submit" size="sm" variant="outline" color="success">
                <i class="fa fa-file-excel-o mr-1"></i> Descargar Excel
              </CButton>

              <!-- <CButton :disabled="!excelFile" type="submit" size="sm" variant="outline" color="success" @click="downloadExcel">
                <i class="fa fa-file-excel-o mr-1"></i> Descargar Excel
              </CButton> -->

            </div>
          </template>


          <template #seleccionar="{item}">
            <td>
              <CInputCheckbox
                :checked="item._selected"
                @update:checked="() => check(item)"
                custom
              />
            </td>
          </template>

          <template #created_at="{item}">
            <td>
              {{ formatDateTimeCustom(item.created_at)}}
            </td>
          </template>

          <template #status="{item}">
            <td>
              <BadgePaymentStatus :badgetText="true" :attribute="item.status" :classBadge="'status-list'"></BadgePaymentStatus>
            </td>
          </template>

          <template #amount="{item}">
            <td class="text-right">
              <!-- TODO: confirmar -->
              <span v-if="item.products[0] && item.products[0].discount" style="text-decoration: line-through;margin-right: 5px; color: gray">
              {{ stringUtils.formatStringPrice( totalPreDiscount(item) ) }} €
              </span>

              {{ stringUtils.formatStringPrice(item.amount) }} €
            </td>
          </template>

          <template #reference="{item}">
             <td class="text-center">
              <span >{{ item.reference ? item.reference : '---' }}</span>
            </td>
          </template>

          <template #method="{item}">
            <td>
              {{ item.payment_method }}
            </td>
          </template>

          <template #parking="{item}">
            <td>
              <div v-if="item.products.length > 0">
                <span v-if="item.products[0].parkings_id">
                  <template v-if="!item.products[0].parking.deleted_at">
                    <router-link target="_blank" class="text-link-list" :to="'/parkings/' + item.products[0].parkings_id">
                      <span>{{ stringUtils.getParkingName(item.products[0].parking) }}</span>
                    </router-link>
                  </template>
                  <template v-else>
                    <span>{{ stringUtils.getParkingName(item.products[0].parking) }}</span>
                  </template>
                </span>
              </div>
            </td>
          </template>

          <!-- <template #clients_id="{item}">
            <td>
              <router-link target="_blank" class="text-link-list" :to="'/gestion/clientes/' + item.client.id">
                {{ item.client.name }}  {{ item.client.surnames }}
              </router-link>
            </td>
          </template> -->

          <template #plan="{item}">
            <td>
              <div v-if="item.products.length > 0">
                <span v-if="item.products[0].plans_id">
                  {{item.products[0].plan.name }}
                </span>
                <span v-else> {{ stringUtils.getProductLabel(item.products[0].product_type) }}</span>
              </div>
            </td>
          </template>

          <template #last4="{item}">
            <td>
             <span v-if="item.credit_card">{{ getCardLast4(item.credit_card) }} </span>
             <span v-else>Sin datos</span>
            </td>
          </template>

          <template #pedido="{item}">
            <td>
             <span v-if="item.products.length > 0">{{ item.products[0].id }} </span>
            </td>
          </template>

          <template #start_datetime="{item}">
            <td>
              {{ formatDateTimeCustom(item.start_datetime)}}
            </td>
          </template>

          <template #end_datetime="{item}">
            <td>
              {{ formatDateTimeCustom(item.end_datetime)}}
            </td>
          </template>

          <!-- <template #invoices_id="{item}">
            <td>
              <CBadge :color="getColorInvoice(item)" class="status-list" >{{ item.invoices_id === null ? 'NO' : item.invoice ? item.invoice.name : 'NO' }}</CBadge>
            </td>
          </template> -->

          <template #invoices_id="{item}">
            <td>

              <!-- min-width: 80px; -->
              <CBadge v-if="!existenDatosCliente(item)"
                color="danger" class="status-list p-1" @click="$emit('showInvoiceAlert', true)"> Sin Datos </CBadge>

              <CBadge v-if="existenDatosCliente(item) && !item.invoices_id && item.status === PAYMENT_PAID.key" @click="generateInvoice(item)" 
                color="warning" class="status-list p-1"> Generar </CBadge>

              <CBadge v-if="existenDatosCliente(item) && item.invoices_id" @click="downloadInvoice(item.invoice)" 
                color="success" class="status-list p-1"> Descargar </CBadge>

            </td>
          </template>

        </CDataTable>


        <nav>
          <div class="overflow-auto">
            <CPagination
              align="center"
              class="md-12"
              v-show="total_paginas > 1"
              :pages="total_paginas"
              :active-page.sync="currentPageSon"
              :per-page="perPage"
              @update:activePage="cambiarPagina"
            />
           <p class="text-muted text-center">Se han encontrado {{getRowCount()}} resultados</p>
          </div>
        </nav>


      </CCardBody>


    </div>

  </CCard>

  <toast ref="toast"></toast>
  </div>
</template>

<script>
import { formatDateTimeCustom, getCardLast4 } from '@/app/shared/utils/utils';
// import Toast from "@/app/shared/components/Toast";
import BadgeStatus from '@/components/badges/BadgeStatus';
import BadgePaymentStatus from '@/components/badges/BadgePaymentStatus';
import stringUtils from "@/app/shared/utils/stringUtils";
import  { generateInvoice } from '@/app/shared/global/services/payment-service';
import { getInvoice } from "@/app/shared/global/services";

import { PAYMENT_PAID }  from '@/config';

export default {
  name: 'PaymentsList',
  components: {
    // Toast,
    BadgeStatus,
    BadgePaymentStatus
  },
  props: {
    elemento:{ type: String, default: 'Pagos'},
    title: { type: String, default: 'Listado de Pagos'},
    loading: Boolean,
    payments: { type: Array, default: [], required: true },
    excel: { type: Boolean, defualt: false},

    rows: { type: Number, default: 0 },
    pagina_actual:  { type: Number, default: 1 },
    currentPage:  { type: Number, default: 1 },
    perPage:  { type: Number, default: 25 },
    total_paginas:  { type: Number, default: 1 },
  },
  data() {
    return {
      formatDateTimeCustom: formatDateTimeCustom,
      campos: [
         // { key: "seleccionar", label: "", thStyle: { width: "50px" }  ,  _style: 'width:1%', sorter: false, filter: false},
        // { key: "id", label: "Id", sorter: true , filter: false,  _style: 'width:5%' },
        { key: "created_at", label: "Fecha de pago", sorter: true, filter: false ,  _classes: 'text-center' },
        { key: "status", label: "Estado", sorter: true, filter: false  },
        { key: "amount", label: "Cantidad", sorter: true,  filter: false },
        { key: "reference", label: "referencia", sorter: true,  filter: false,  _classes: 'text-center'    },
        // { key: "pedido", label: "Número de pedido", sorter: true,  filter: false,  _classes: 'text-center'    },
        { key: "last4", label: "Tarjeta de crédito", sorter: true,  filter: false ,  _classes: 'text-center'  },
        // { key: "method", label: "Método de pago", sorter: true,  filter: false,  _classes: 'text-center', _style: 'width:10%'  },
        { key: "parking", label: "Parking", sorter: true, filter: false },
        { key: "plan", label: "Plan", sorter: true, filter: false },
        // { key: "clients_id", label: "Cliente", sorter: true , filter: false},
        { key: "invoices_id", label: "Factura", sorter: true, filter: false },
        // { key: "acciones", label: "Acciones", _style: 'width:15%', sorter: false, filter: false},
      ],
      modelDelete: false,
      allChecked:false,
      stringUtils: stringUtils,
      getCardLast4: getCardLast4,
      PAYMENT_PAID: PAYMENT_PAID
    }
  },
  mounted(){
  },
  created(){
  },
  computed: {
    items: function () {
      return [...this.payments]
    },
    // items:{
    //   get: function () {
    //     return this.payments;
    //   },
    //   set: function (newValue) {
    //     this.$emit("update:payments", newValue);
    //   },
    // },
    currentPageSon: {
      get: function() {
        return this.currentPage;
      },
      set: function(newValue) {
        this.$emit('update:currentPage', newValue)
      }
    },
    paymentsList: function () {
      if (this.items) {
        return this.items.map(user => {
          return {
            ...user,
            _classes: [
              user._classes,
              user._selected ? 'table-selected' : 'table-unselected'
            ]
          }
        })
      }
    },
  },
  methods: {
    selectToEdit(item){
      this.$emit('select', item)
    },
    selectToDelete(item){
      this.$emit('delete', item)
    },
    getRowCount: function() {
      return this.rows;
    },
    cambiarPagina(e) {
      this.$emit('cambiarPagina', e)
    },
    selectAllItems(){
      if (this.items.every( item => item._selected === true)){
        this.$emit('updateChecked', false);
        this.allChecked = false;

      } else {
        this.$emit('updateChecked', true);
        this.allChecked = true;
      }
    },
    goToDetail(item, index, column, e){
      // this.$emit('select', item)
      if (!['INPUT', 'LABEL'].includes(e.target.tagName)
      && !['client', 'parking', 'acciones', 'invoices_id'].includes(column)) {
        this.$router.push({ path: "/gestion/pagos/" + item.id });
        // let routeData = this.$router.resolve({path: `/gestion/contrataciones/${item.id}` });
        // window.open(routeData.href, '_blank');
      }
    },
    check (item) {
      const data = this.items.filter( user => user.id == item.id)[0];
      const val = Boolean(this.items[this.items.indexOf(data)]._selected);

      this.items[this.items.indexOf(data)]._selected = !val;
      this.items[this.items.indexOf(data)].checked = !val;

      this.items = [...this.items];
    },
    getColorInvoice(item){
      // invoices_id
      // return 'secondary'
      return item.invoices_id === null ? 'secondary'
        : item.invoice ? 'primary' : 'secondary'
    },
    generateExcel(){

      // &to_excel=1
      //  const is_excel = true;
      this.$emit('excel', true)

    },


    async generateInvoice(payment){

      try {

        const invoice = await generateInvoice(payment.id);

        if(!invoice) {
          return
        }

        this.$emit('updateData');

        this.downloadInvoice(invoice.data);

      }catch(e) {
        this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');
      }
    },

    existenDatosCliente(payment){
      return payment?.client ? payment?.client.has_billing_info : false;
    },

    async downloadInvoice(invoice){

      try { 
        const response = await getInvoice(invoice).catch(e => {
          resetResponseType();
          this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');
        });

        if (response) {
          this.downloadInvoicePdf(response, invoice);
          // this.forceFileDownload(response, invoice);
        }
      }catch(e) {
        this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');
      }
      
    },


    downloadInvoicePdf(response, invoice) {
      
      const file = new Blob([response.data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      // const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

      // Open in browser
      // window.location.href = fileURL;
      const link = document.createElement('a');
      link.href = fileURL;
  
 
      link.setAttribute('download', invoice.reference + '' );
      document.body.appendChild(link);
      link.click();

      this.$refs.toast.showToast('Factura descargada con éxito', null, 'success', '2000');

      document.body.removeChild(link);

      // setTimeout(() => {
      //   // For Firefox it is necessary to delay revoking the ObjectURL
      //   // document.removeChild(link);
      //   window.URL.revokeObjectURL(fileURL);
      // }, 100);
    },

    totalDiscount(payment) {
      return payment.products.reduce((total, actual) => total + actual.discount_amount, 0);
    },
    totalPreDiscount(payment){
      // payment.products.map(item => item.amount ).reduce((pre, actual) => pre + actual );
      return payment.products.reduce((total, actual) => total + actual.amount, 0);
    }



  }


}
</script>

<style lang="scss">

</style>

